import { render, staticRenderFns } from "./FluxRegaloStep4.vue?vue&type=template&id=72a8df7d"
import script from "./FluxRegaloStep4.vue?vue&type=script&lang=js"
export * from "./FluxRegaloStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports